import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { CompanyType } from '@planning/app/api'
import { CompanyAutocomplete } from '@planning/components/autocompletes/company-autocomplete/CompanyAutocomplete'
import { containerHeights, containerTypes } from '@planning/constants'
import { useTranslate } from '@tolgee/react'
import {
  CustomInputAdornment,
  useContainerAttributesParameters,
  useMinimalsTheme,
} from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { UnitNumberController } from './UnitNumberController'

export const SwapBodyInfoForm: FC = observer(() => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()
  const { types: containerTypeParameters } = useContainerAttributesParameters()

  const { formState, control } = useFormContext()

  const { errors } = formState

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <UnitNumberController
          control={control}
          errors={errors}
          label={t('swapBodyNo', 'Swap body no.')}
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <Controller
          name='operator'
          control={control}
          rules={{
            required: false,
          }}
          render={({ field }) => (
            <CompanyAutocomplete
              label={t('operator', 'Operator')}
              selectedCompanyShortName={field.value}
              dataCy='operator-autocomplete'
              handleOnChange={operator => {
                field.onChange(operator?.shortName)
              }}
              filterByTypes={[CompanyType.ShippingLine]}
              data-cy='container-operator-field'
            />
          )}
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <Controller
          name='length'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              data-cy='container-length'
              label={`${t('length', 'Length')}`}
              fullWidth
              variant='outlined'
              type='text'
              name='length'
              onChange={event => field.onChange(event.target.value.toUpperCase())}
              error={!!errors.length}
              helperText={errors.length && t('fieldIsRequired', 'Field is required.')}
              InputProps={{
                endAdornment: (
                  <CustomInputAdornment
                    position='end'
                    color='secondary'
                    padding={theme.customSpacing.l}
                  >
                    ft
                  </CustomInputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <FormControl fullWidth>
          <InputLabel>{t('height', 'Height')}</InputLabel>
          <Controller
            name='height'
            control={control}
            render={({ field }) => (
              <Select data-cy='container-height' {...field} label='Height'>
                {containerHeights.map(d => {
                  return (
                    <MenuItem key={d.key} value={d.name}>
                      {d.name}
                    </MenuItem>
                  )
                })}
              </Select>
            )}
          />
        </FormControl>
      </Grid>
      <Grid size={12}>
        <FormControl fullWidth>
          <InputLabel>{`${t('unitType', 'Unit Type')}`}</InputLabel>
          <Controller
            name='type'
            control={control}
            render={({ field }) => (
              <Select {...field} label={`${t('unitType', 'Unit Type')} *`} data-cy='container-type'>
                {containerTypes
                  ?.filter(d => containerTypeParameters[d.name]?.label)
                  .map(d => (
                    <MenuItem key={d.key} value={d.name}>
                      {containerTypeParameters[d.name].label}
                    </MenuItem>
                  ))}
              </Select>
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  )
})
